export default __webpack_public_path__ + "static/media/logoutIcon.2a9b311a.svg";